export interface UiAccessibilityPolicy {
  id: string;
  version: string;
  minimumBodyFontPx: number;
  minimumTouchTargetPx: number;
  minimumTextLineHeight: number;
  visibleKeyboardFocus: true;
  respectsReducedMotion: true;
  mobileChartPresentation: 'single_focus_palace';
  desktopChartPresentation: 'twelve_palace_grid';
  browserPrintCss: true;
  printHidesInteractiveControls: true;
  evidenceAppendixRequiresOptIn: true;
  disclosure: string;
}

export const DEFAULT_UI_ACCESSIBILITY_POLICY: UiAccessibilityPolicy = Object.freeze({
  id: 'UI-ACCESSIBILITY-BASELINE',
  version: '1.0.0',
  minimumBodyFontPx: 16,
  minimumTouchTargetPx: 44,
  minimumTextLineHeight: 1.5,
  visibleKeyboardFocus: true,
  respectsReducedMotion: true,
  mobileChartPresentation: 'single_focus_palace',
  desktopChartPresentation: 'twelve_palace_grid',
  browserPrintCss: true,
  printHidesInteractiveControls: true,
  evidenceAppendixRequiresOptIn: true,
  disclosure: '此為專案的 Accessibility 工程基線，不宣稱僅靠這份契約即可自動達成完整無障礙標準；正式瀏覽器 UI 仍需鍵盤、螢幕閱讀器、縮放與對比實測。',
});

export function assertUiAccessibilityPolicy(policy: UiAccessibilityPolicy = DEFAULT_UI_ACCESSIBILITY_POLICY): void {
  if (policy.minimumBodyFontPx < 16) throw new Error('UI accessibility policy body text must be at least 16 CSS px');
  if (policy.minimumTouchTargetPx < 44) throw new Error('UI accessibility policy touch targets must be at least 44 CSS px');
  if (policy.minimumTextLineHeight < 1.5) throw new Error('UI accessibility policy text line height must be at least 1.5');
  if (!policy.visibleKeyboardFocus) throw new Error('UI accessibility policy must preserve visible keyboard focus');
  if (!policy.respectsReducedMotion) throw new Error('UI accessibility policy must respect reduced-motion preference');
  if (policy.mobileChartPresentation !== 'single_focus_palace') throw new Error('Mobile chart must use the readable single-focus palace presentation');
  if (!policy.browserPrintCss || !policy.printHidesInteractiveControls) throw new Error('UI accessibility policy must retain browser-print CSS with interactive controls hidden');
  if (!policy.evidenceAppendixRequiresOptIn) throw new Error('Detailed evidence appendix must remain explicit opt-in for print');
}
